export function initTableCrossHover(root = document) {
  root.querySelectorAll(".table--cross-hover").forEach((table) => {
    if (table.dataset.crossHoverInitialized === "1") return;
    table.dataset.crossHoverInitialized = "1";

    const cellSelector = ".table--cross-hover > :is(thead, tbody) > tr > :is(th, td)";
    const columns = new Map();
    table.querySelectorAll(cellSelector).forEach((cell) => {
      if (cell.closest("table") !== table) return;
      const key = cell.cellIndex;
      if (!columns.has(key)) columns.set(key, []);
      columns.get(key).push(cell);
    });

    const highlightedClass = "table__cell--highlighted";
    let highlighted = [];
    let activeColumn = null;
    const clear = () => {
      highlighted.forEach((cell) => cell.classList.remove(highlightedClass));
      highlighted = [];
      activeColumn = null;
    };
    const highlight = (event) => {
      const cell = event.target.closest(cellSelector);
      const column = cell?.closest("table") === table ? cell.cellIndex : null;
      if (column === activeColumn) return;
      clear();
      activeColumn = column;
      highlighted = columns.get(column) || [];
      highlighted.forEach((item) => item.classList.add(highlightedClass));
    };
    table.addEventListener("pointerover", highlight);
    table.addEventListener("pointerleave", clear);
    table.addEventListener("focusin", highlight);
    table.addEventListener("focusout", clear);
  });
}
